import { gql } from '@apollo/client';

export const CREATE_PERMIT_APPLICATION = gql`
  mutation createPermitApplication($input: CreatePermitApplicationInput!) {
    createPermitApplication(input: $input) {
      created
    }
  }
`;
